/* Universal dropdown-select component */
(function () {
	'use strict';

	function initDropdown(container) {
		const isInitialized = container.__dropdownInitialized;
		if (isInitialized) return;
		container.__dropdownInitialized = true;

		const toggle =
			container.querySelector('[data-dropdown-toggle]') ||
			container.querySelector('.dropdown__toggle');
		const menu =
			container.querySelector('[data-dropdown-menu]') ||
			container.querySelector('.dropdown__menu');
		const hiddenInput =
			container.querySelector('[data-dropdown-input]') ||
			container.querySelector('input[type="hidden"]');
		const titleEl =
			container.querySelector('[data-dropdown-title]') ||
			container.querySelector('[data-sort-title]');

		const optionNodes = Array.from(
			container.querySelectorAll(
				'[data-option-value], [data-sort-option], .dropdown__option, .filter__option'
			)
		);

		function getOptionValue(node) {
			return (
				node.getAttribute('data-option-value') ||
				node.getAttribute('data-sort-option') ||
				(node.querySelector('input[type="radio"]') || {}).value ||
				''
			);
		}

		function getOptionLabel(node) {
			return (
				node.getAttribute('data-option-label') ||
				node.getAttribute('data-sort-label') ||
				node.textContent.trim()
			);
		}

		function openMenu() {
			container.classList.add('is-open');
			toggle && toggle.setAttribute('aria-expanded', 'true');
		}

		function closeMenu() {
			container.classList.remove('is-open');
			toggle && toggle.setAttribute('aria-expanded', 'false');
		}

		function toggleMenu() {
			if (container.classList.contains('is-open')) closeMenu();
			else openMenu();
		}

		function setActiveByValue(value) {
			optionNodes.forEach((node) => {
				const match = getOptionValue(node) === value;
				node.classList.toggle('is-active', match);
				const radio = node.querySelector('input[type="radio"]');
				if (radio) radio.checked = match;
			});
		}

		function dispatchChanged(value) {
			const name =
				(container.getAttribute('data-dropdown-name') ||
					(hiddenInput && hiddenInput.name) ||
					'') + '';
			const evt = new CustomEvent('dropdown:change', {
				bubbles: true,
				detail: { name, value },
			});
			container.dispatchEvent(evt);
		}

		function updateSelection(value, label) {
			if (hiddenInput) hiddenInput.value = value;
			if (titleEl && label) titleEl.textContent = label;
			setActiveByValue(value);
			dispatchChanged(value);
		}

		// init from current value
		(function initState() {
			let currentValue = hiddenInput ? hiddenInput.value : '';
			if (!currentValue) {
				const checkedRadio = optionNodes
					.map((n) => n.querySelector('input[type="radio"]'))
					.find((r) => r && r.checked);
				if (checkedRadio) currentValue = checkedRadio.value;
			}
			let currentLabel = '';
			const activeNode =
				optionNodes.find((n) => getOptionValue(n) === currentValue) ||
				optionNodes[0];
			if (activeNode) {
				currentValue = getOptionValue(activeNode);
				currentLabel = getOptionLabel(activeNode);
			}
			updateSelection(currentValue, currentLabel);
			closeMenu();
		})();

		// events
		if (toggle) {
			toggle.setAttribute('aria-haspopup', 'listbox');
			toggle.setAttribute('aria-expanded', 'false');
			toggle.addEventListener('click', function (e) {
				e.preventDefault();
				toggleMenu();
			});
			toggle.addEventListener('keydown', function (e) {
				if (e.key === 'Enter' || e.key === ' ') {
					e.preventDefault();
					toggleMenu();
				} else if (e.key === 'Escape') {
					closeMenu();
				}
			});
		}

		optionNodes.forEach((node) => {
			node.addEventListener('click', function (e) {
				e.preventDefault();
				const value = getOptionValue(node);
				const label = getOptionLabel(node);
				updateSelection(value, label);
				closeMenu();
			});
		});

		document.addEventListener('click', function (e) {
			if (!container.contains(e.target)) closeMenu();
		});
		menu &&
			menu.addEventListener('keydown', function (e) {
				if (e.key === 'Escape') {
					closeMenu();
					toggle && toggle.focus();
				}
			});
	}

	function initAll() {
		document
			.querySelectorAll('[data-dropdown], .dropdown[data-sort-dropdown]')
			.forEach(initDropdown);
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', initAll);
	} else {
		initAll();
	}
})();


